// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"646e9ba0","515":"6299aa83"}[chunkId] + ".chunk.js";
};